import React from 'react';
import BaseInput from '../../General/FormsComp/Input/BaseInput';

const FormInput = ({ label, type = 'text', name, value, onChange, required = false, placeholder, min, step }) => {
  return (
    <BaseInput
      label={label}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      min={min}
      step={step}
    />
  );
};

export default FormInput;

